import { Link } from 'react-router-dom';
import { useLanguage } from '../../shell/language-context';
import './not-found.css';

// Generic 404 — the design's empty-state pattern (spec §2.10 adapted): icon tile,
// title, sub, and a home CTA.
export function NotFoundScreen() {
  const { t } = useLanguage();
  return (
    <div className="nfz">
      <div className="nfz__icon" aria-hidden="true">⌕</div>
      <h1 className="nfz__title">{t('notfound.title')}</h1>
      <p className="nfz__sub">{t('notfound.body')}</p>
      <Link to="/" className="nfz__btn">{t('notfound.home')}</Link>
    </div>
  );
}
